class TileController {}

const tileComponentDefinition = {
    bindings: {
        item: '<',
        isEditing: '<?',
        onRemove: '&?',
    },
    controller: TileController,
    template: require('./tile.component.html').trim(),
};

module.exports = {
    TileController,
    tileComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/tile.component.js